import PlayerI18n from './Player/Player.i18n.en';
import ConfirmationModal from './Components/DpConfirmationModal.i18n.en';
export default {
  attempt: {
    ...PlayerI18n,
    ...ConfirmationModal
  }
};